import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["href"]

import sprite from '@/assets/icons/sprite.svg';
import { IconName, IconSize } from '@/models/icon-types';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppIcon',
  props: {
    name: {},
    size: { default: IconSize.BodyM },
    className: {},
    clickable: { type: Boolean },
    onClick: {}
  },
  setup(__props: any) {

function dataURItoBlobUrl(dataURI: string): string {
  const svg = decodeURI(dataURI).split(',')[1];
  if (!svg) {
    return dataURI;
  }
  const blob = new Blob([svg], { type: 'image/svg+xml' });

  return URL.createObjectURL(blob);
}

const props = __props;
const spriteUrl = dataURItoBlobUrl(`${sprite}`);

const handleClick = () => {
  if (props.onClick) {
    props.onClick();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'app-icon': true,
      'clickable-icon': props.clickable,
      [`app-icon--${_ctx.size}`]: _ctx.size,
      [_ctx.className ?? '']: _ctx.className
    }),
    onClick: handleClick
  }, [
    (_openBlock(), _createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: _normalizeClass({ 'app-icon': true, [`app-icon--${_ctx.size}`]: _ctx.size }),
      role: "img",
      "aria-label": _ctx.name
    }, [
      _createElementVNode("use", {
        href: `${_unref(spriteUrl)}#${_ctx.name}`
      }, null, 8, _hoisted_2)
    ], 10, _hoisted_1))
  ], 2))
}
}

})